import { toast } from "sonner";
import { Spinner } from "@/components/Common";
import { MatchChip, Missing } from "@/components/si/Bits";
import { useCandidates } from "@/components/si/Candidates";
import { STAGES, pretty, siErr, siPatch } from "@/lib/sourcing";

export const Pipeline = ({ project: p }) => {
  const q = useCandidates(p.id, "sort=match&limit=500");
  const items = q.data?.items || [];
  const move = async (c, stage) => {
    q.setData((d) => ({ ...d, items: d.items.map((x) => (x.id === c.id ? { ...x, stage } : x)) }));
    try { await siPatch(`/projects/${p.id}/candidates/${c.id}`, { stage }); } catch (e) { toast.error(siErr(e)); q.reload(); }
  };
  if (q.missing) return <Missing what="Needs GET /admin/si/projects/{id}/candidates." />;
  if (q.loading && !q.data) return <Spinner className="h-6 w-6 text-[#D4AF37]" />;
  return (
    <div className="flex gap-3 overflow-x-auto pb-3" data-testid="si-pipeline">
      {STAGES.map((s) => {
        const col = items.filter((c) => (c.stage || "discovered") === s);
        return (
          <div key={s} className="flex w-[260px] shrink-0 flex-col gap-2 rounded-xl border border-[#27272A] bg-[#121215] p-3" data-testid={`si-col-${s}`}
            onDragOver={(e) => e.preventDefault()} onDrop={(e) => { const c = items.find((x) => x.id === e.dataTransfer.getData("id")); if (c && c.stage !== s) move(c, s); }}>
            <p className="flex justify-between text-[11px] font-semibold uppercase tracking-wider text-zinc-400">{pretty(s)}<span className="text-zinc-600">{col.length}</span></p>
            {col.map((c) => (
              <div key={c.id} draggable onDragStart={(e) => e.dataTransfer.setData("id", c.id)} className="cursor-grab rounded-lg border border-[#27272A] bg-[#09090B] p-2.5 transition-colors hover:border-[#D4AF37]/40" data-testid={`si-card-${c.id}`}>
                <p className="truncate text-sm text-zinc-100">{c.full_name}</p>
                <p className="truncate text-[10px] text-zinc-500">{c.current_title || "UNKNOWN"}</p>
                <div className="mt-1.5 flex items-center gap-1.5"><span className="font-mono text-xs text-zinc-300">{c.match?.overall_score ?? "—"}</span><MatchChip v={c.match?.overall_score} />{c.recruiter_name && <span className="ml-auto truncate text-[10px] text-zinc-500">{c.recruiter_name}</span>}</div>
                <select value={c.stage || "discovered"} onChange={(e) => move(c, e.target.value)} className="mt-2 h-7 w-full rounded border border-[#27272A] bg-[#121215] px-1 text-[10px] text-zinc-300" data-testid={`si-card-${c.id}-stage`}>{STAGES.map((x) => <option key={x} value={x}>{pretty(x)}</option>)}</select>
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};
